import React, { useEffect, useState, useMemo} from "react"
import SampleGraph from './SampleGraph'
import { NoContent } from '../utils/tools'
import { Divider } from '@mui/material'
import { useProject } from "../context/project"
import { GarphProvider } from "../context/graphContext"
import InsightPanel from '../components/correlation/components/InsightPanel'
import { Skeleton } from '@mui/material'
import axios from "axios"

export default function SampleGraphContainer({ dataset, ticker, financialInfo, analyze, sectionId, prevAnalyze}) {
    const [ graphsId, setdGraphsId ] = useState(null)
    const { privateCompany } = useProject()

    const getGraph = async (graphId) => {
        const resJson = await axios.get(`/api/getGraph?graphId=${graphId}`)
        const res = await resJson.data
        return { fig: res.layers, displayMethod: res.displayMethod, timeRange: res.timeRange, timeFrame: res.timeFrame,correlation:res.correlation}
    }
    
    const getGraphFunction = async (data, graphId) => {
        // const resJson = await fetch('/api/getGraphFunction', {
        //     method: 'post',
        //     headers: {'Content-Type': 'application/json'},
        //     body: JSON.stringify({...data, graphId})
        // })
        const resJson = await axios({
            method: 'post',
            url: '/api/getGraphFunction',
            data: {...data, graphId}
        })
        const res = await resJson.data
        return { ...data, fig: res.layers, correlation:res.correlation }
    }

    const initialGraph = {
        fig: null,
        displayMethod:'NONE',
        timeRange: 'ALL',
    } 

    useEffect(() => {
        if (prevAnalyze < analyze) { 
            setdGraphsId(null)
            // fetch('/api/getSimpleGraph',{
            //     method: 'post',
            //     headers: {'Content-Type': 'application/json'},
            //     body: JSON.stringify({dataset, ticker, timeLeg:0, financialInfo, fileName:'', sectionId, privateCompany})
            // })
            axios({
                method: 'post',
                url: '/api/getSimpleGraph',
                data: {dataset, ticker, timeLeg:0, financialInfo, fileName:'', sectionId, privateCompany}
            }).then(res => res.data).then(res => {
                setdGraphsId(res.graphIds)
            })
        } else {
            axios.get(`/api/getVisualizationGraphs?sectionId=${sectionId}`).then(res => res.data).then(res => {
                setdGraphsId(res)
            })
        }
        return () => setdGraphsId([])
    }, [analyze]) // eslint-disable-line

    const renderGraphs= (graphId) => (
        <GarphProvider key={graphId} graphId={graphId} getGraphFunction={getGraphFunction} getGraph={getGraph} initialGraph={initialGraph}>
            <InsightPanel />
            <SampleGraph graphId={graphId}/>
        </GarphProvider>
    )

    const graphs = useMemo(()=>{
        if(!graphsId) {return []}
        let graph_array =  graphsId.flatMap((graphId, index) => ([renderGraphs(graphId),<Divider key={`divider-${index}`}/>]))
        graph_array.splice(-1, 1)
        return graph_array
    }, [graphsId]) // eslint-disable-line

    const renderData = () => (
        graphs.length ? graphs : <div className='graph'><NoContent /></div>
    )

    return ( graphsId ?  renderData() : <Skeleton width='100%' height='500px'/> )
}